export const MODULE_ROUTE = {
  LOGIN: "/login",
  PROFILE: "/profile",
  FORGOT_PASSWORD: "/forgot-password",
  CHANGE_PASSWORD: "/change-password",
  BRAND: "/brand",
  ADMIN: "/admin",
  PROMOTION_CAMPAIGN_TYPE: "/promotion-campaign-type",
  PROMOTION_ASSIGN_BRAND: "/promotion-assign-brand",
  BRAND_CAMPAIGNS: "/brand-campaign",
  BANNER_PAGE: "/banner",
  APP_VERSION: "/app-version",
  COMPANIES: "/",
};
